import React, { useEffect, useState } from "react";
import { server } from "../../../common";
import { toast } from "react-toastify";
import { AxiosError } from "axios";
import { useSelectAccess } from "../../../store/stateFunctions";
import { FaSearch } from "react-icons/fa";

const MyNetwork = () => {
  const user = useSelectAccess("Student");
  const [data, setData] = useState([]);
  const [searchTerm, setSearchTerm] = useState("");

  useEffect(() => {
    getData();
  }, []);

  // Get Data
  const getData = () => {
    server
      .get("/register/mynetwork", {
        headers: {
          "Content-Type": "application/json",
          Authorization: user.authToken,
        },
      })
      .then(function (response) {
        console.log("API Response:", response.data);
        if (response.status === 200 || response.status === 201) {
          setData(response.data);
        }
      })
      .catch(function (error) {
        if (error instanceof AxiosError && error.response?.data?.message)
          toast.error(error.response.data.message);
        else if (error.response?.data?.error) {
          toast.error(error.response.data.error);
        } else toast.error("Failed to connect to server");
      });
  };

  return (
    <div className="container mt-4">
      {/* Search Bar */}
      <div className="row justify-content-center mb-4">
        <div className="col-md-6">
          <div className="input-group shadow-sm">
            <span className="input-group-text bg-white">
              <FaSearch className="text-muted" />
            </span>
            <input
              type="text"
              placeholder="Search by name or ID..."
              className="form-control"
              onChange={(e) => setSearchTerm(e.target.value)}
            />
          </div>
        </div>
      </div>

      {/* Cards Grid */}
      <div className="row">
        {data
          .filter((item) =>
            item.name.toLowerCase().includes(searchTerm.toLowerCase())
          )
          .map((item, index) => (
            <div key={index} className="col-md-4 col-sm-6 mb-4">
              <div className="card shadow-sm border-0 rounded-3 p-3 justify-content-center text-center">
                <h5 className="text-primary">{item.taluka}</h5>
                <img
                  src={item.profile_photo}
                  alt="Profile"
                  className="rounded-circle border p-1"
                  width={100}
                  height={100}
                />
                <h5 className="mt-2 fw-bold">{item.name}</h5>

                <p className="mb-2">
                  <span className="fw-bold text-secondary">ID: </span>
                  <span className="text-dark">{item.id}</span>
                </p>

                <table className="table table-border">
                  <tbody>
                    <tr>
                      <td className="text-muted">📞 Contact:</td>
                      <td>{item.contactno}</td>
                    </tr>
                    <tr>
                      <td className="text-muted">🏡 Village:</td>
                      <td>{item.village}</td>
                    </tr>
                    <tr>
                      <td className="text-muted">🌍 District:</td>
                      <td>{item.district}</td>
                    </tr>
                  </tbody>
                </table>
              </div>
            </div>
          ))}
      </div>
    </div>
  );
};

export default MyNetwork;
